import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-testid"]
const _hoisted_2 = ["data-testid"]
const _hoisted_3 = { class: "w-full flex flex-col gap-0.5 overflow-hidden text-left" }
const _hoisted_4 = { class: "text-sm font-bold text-textPrimary truncate" }
const _hoisted_5 = { class: "text-xs text-neutral50 truncate" }
const _hoisted_6 = { class: "text-sm text-textPrimary whitespace-nowrap" }
const _hoisted_7 = { class: "text-sm text-textPrimary whitespace-nowrap" }
const _hoisted_8 = { class: "text-sm text-textPrimary whitespace-nowrap" }
const _hoisted_9 = ["data-testid"]
const _hoisted_10 = { class: "w-full flex justify-center" }

import TableModular from '@/components/designSystem/Table/TableModular/TableModular.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import DoctorInfo from '@/components/DoctorInfo.vue'
import { truncateText } from '@/utils/string'
import { CheckValidationStatus } from '@/Network/Types/Responses/CheckValidationResponses'
import CheckValidationStatusBadge from './CheckValidationStatusBadge.vue'
import { COLUMNS, UNIT_NAME_MAX_LENGTH } from '../constants'
import { DISPLAY_FALLBACK } from '../mappers'
import type { CheckValidationRow } from '../types'


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckValidationTable',
  props: {
    rows: {},
    isEvidenceUnavailable: {},
    isRetired: { type: Boolean, default: false }
  },
  emits: ["evaluate", "details"],
  setup(__props: any, { emit }) {





const isPending = (row: CheckValidationRow) => row.status === CheckValidationStatus.PENDING_REVIEW

const doctorTooltip = (row: CheckValidationRow): string =>
  row.doctor.crmLabel
    ? `${row.doctor.name ?? ''} — ${row.doctor.crmLabel}`
    : (row.doctor.name ?? '')

return (_ctx: any,_cache: any) => {
  const _component_v_tooltip = _resolveComponent("v-tooltip")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(TableModular, {
      rows: _ctx.rows,
      columns: _unref(COLUMNS),
      "actions-label": "Ações",
      "actions-width": "160px"
    }, {
      "column-registro": _withCtx(({ row }) => [
        _createElementVNode("span", {
          class: "text-xs text-neutral50 font-mono",
          "data-testid": `check-validation-id-${row.checkId}`
        }, " #" + _toDisplayString(row.checkId), 9, _hoisted_1)
      ]),
      "column-medico": _withCtx(({ row }) => [
        _createElementVNode("div", {
          class: "w-full flex justify-start",
          "data-testid": `check-validation-row-${row.checkId}`
        }, [
          _createVNode(DoctorInfo, {
            name: row.doctor.name,
            subtitle: row.doctor.crmLabel ?? _unref(DISPLAY_FALLBACK),
            size: "sm",
            truncate: ""
          }, null, 8, ["name", "subtitle"]),
          _createVNode(_component_v_tooltip, {
            activator: "parent",
            location: "top",
            text: doctorTooltip(row as CheckValidationRow)
          }, null, 8, ["text"])
        ], 8, _hoisted_2)
      ]),
      "column-unidade": _withCtx(({ row }) => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(truncateText)(row.unit, _unref(UNIT_NAME_MAX_LENGTH))), 1),
          _createElementVNode("span", _hoisted_5, _toDisplayString(row.scheduleLabel), 1),
          _createVNode(_component_v_tooltip, {
            activator: "parent",
            location: "top",
            text: `${row.unit} · ${row.scheduleLabel}`
          }, null, 8, ["text"])
        ])
      ]),
      "column-data": _withCtx(({ row }) => [
        _createElementVNode("span", _hoisted_6, _toDisplayString(row.stationDate), 1)
      ]),
      "column-previsto": _withCtx(({ row }) => [
        _createElementVNode("span", _hoisted_7, _toDisplayString(row.expectedRange), 1)
      ]),
      "column-digitado": _withCtx(({ row }) => [
        _createElementVNode("span", _hoisted_8, _toDisplayString(row.typedRange), 1)
      ]),
      "column-dif": _withCtx(({ row }) => [
        _createElementVNode("span", {
          class: _normalizeClass(["text-sm whitespace-nowrap", row.diffMinutes ? 'font-bold text-textPrimary' : 'text-neutral50']),
          "data-testid": `check-validation-diff-${row.checkId}`
        }, _toDisplayString(row.diffLabel), 11, _hoisted_9)
      ]),
      "column-status": _withCtx(({ row }) => [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(CheckValidationStatusBadge, {
            status: row.status,
            "is-overdue": row.isOverdue,
            "is-edited-since-submit": row.isEditedSinceSubmit,
            "is-evidence-unavailable": _ctx.isEvidenceUnavailable(row as CheckValidationRow)
          }, null, 8, ["status", "is-overdue", "is-edited-since-submit", "is-evidence-unavailable"])
        ])
      ]),
      actions: _withCtx(({ row }) => [
        (isPending(row as CheckValidationRow))
          ? (_openBlock(), _createBlock(OutlineButton, {
              key: 0,
              text: "Avaliar registro",
              width: "auto",
              height: "32px",
              disabled: _ctx.isRetired,
              "data-testid": `check-validation-evaluate-${row.checkId}-button`,
              onClick: ($event: any) => (emit('evaluate', row as CheckValidationRow))
            }, null, 8, ["disabled", "data-testid", "onClick"]))
          : (_openBlock(), _createBlock(OutlineButton, {
              key: 1,
              text: "Detalhes",
              width: "auto",
              height: "32px",
              "data-testid": `check-validation-details-${row.checkId}-button`,
              onClick: ($event: any) => (emit('details', row as CheckValidationRow))
            }, null, 8, ["data-testid", "onClick"]))
      ]),
      _: 1
    }, 8, ["rows", "columns"])
  ]))
}
}

})